import React, { useCallback, useEffect, useState } from 'react';
import { AiOutlineEye } from 'react-icons/ai';
import Table from 'src/components/table';
import DashboardLayout from 'src/containers/dashboard-layout';
import Service from 'src/setup/network';

const ViewRefund = () => {
  const [refundedReceiptData, setRefundedReceiptData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchRefundedReceiptData = useCallback(async () => {
    setIsLoading(true);
    try {
      const res = await Service.get('/payments/refund');
      const data = await res?.data;
      setRefundedReceiptData(data);
      setIsLoading(false);
    } catch (err) {}
  }, []);

  useEffect(() => {
    fetchRefundedReceiptData();
  }, []);

  const tableColumn = [
    {
      Header: 'Receipt ID',
      accessor: '',
      Cell: (row: any) => {
        return <div>{row?.cell?.row?.original?.receiptInfo?.id}</div>;
      },
    },
    {
      Header: 'Item',
      accessor: 'item',
      Cell: (row: any) => {
        return (
          <div>
            {row?.cell?.row?.original?.items.map((item: any) => (
              <p key={item.id}>{item.itemName}</p>
            ))}
          </div>
        );
      },
    },
    {
      Header: 'Modifiers',
      accessor: '',
      Cell: (row: any) => {
        return (
          <div>
            {row?.cell?.row?.original?.items.map((item: any) => {
              return (
                <>
                  {item.modifiers.map((modifiers: any) => (
                    <p key={modifiers?.id}>{modifiers?.name}</p>
                  ))}
                </>
              );
            })}
          </div>
        );
      },
    },
    {
      Header: 'Options',
      accessor: '',
      Cell: (row: any) => {
        return (
          <div>
            {row?.cell?.row?.original?.items.map((item: any) => {
              return (
                <>
                  {item.modifiers.map((modifiers: any) => {
                    return (
                      <>
                        {modifiers?.options?.map((option: any) => (
                          <p key={option?.id}>{option?.name}</p>
                        ))}
                      </>
                    );
                  })}
                </>
              );
            })}
          </div>
        );
      },
    },
    {
      Header: 'Amount',
      accessor: 'amount',
    },
  ];
  return (
    <>
      <div className="pb-10">
        <Table
          pagination={true}
          tableColumn={tableColumn}
          tableData={refundedReceiptData}
        />
      </div>
    </>
  );
};

export default ViewRefund;
